<template >
<div name="unitfilelist">

                    <div
                      class="
                        absolute
                        top-0
                        w-4
                        h-4
                        origin-center
                        transform
                        rotate-45
                        translate-x-5
                        -translate-y-2
                        bg-white
                        border-t border-l border-gray-200
                        rounded-sm
                        pointer-events-none
                        ml-48
                      "
                    ></div>
                    <div class=" h-screen max-h-screen overflow-y-auto mb-10 pb-10">
                     
            <table class="w-full table-wrapper mb-6">
              <th colspan="2" class="text-left bg-gray-100 p-2 text-gray-500  ">Unit General</th>
              <tbody >
                <tr v-for="item in filesList" :key="item.identifier" @click="displayResource(item)" 
                class="hover:bg-opacity-50 cursor-pointer"
                 
                >
                  <td class="w-10/12">
                    <span class="pl-2">
                      <i class="icon fas mr-2" v-bind:class="showIcon(item)"></i>
                    {{item.title}}
                    </span>
                   </td>
                  <td class="w-1/12 px-6 text-sm text-action-blue" >
                    View
                  </td>
                </tr>
              </tbody>
            </table>
                     
            <table class="w-full table-wrapper" v-if="hasLessonFiles">
              <th colspan="3" class="text-left bg-gray-100 p-2 text-gray-500 ">{{lesson.name}}</th>
              <tbody>
                <tr v-for="item in lessonFiles" :key="item.identifier" @click="displayResource(item)" class="hover:bg-opacity-50 cursor-pointer"
                 
                >
                <td class="w-3/12">
                  <span class="pl-2 text-xs opacity-50 uppercase">
                      <i class="icon fas mr-2" v-bind:class="showIcon(item)"></i>
                      {{ item.format }}
                    
                    </span>
                 
                  </td>

                  <td class="w-8/12">
                    {{item.title}}
                   </td>
                  <td class="w-1/12 px-6 text-sm text-action-blue" >
                    View
                  </td>
                </tr>
              </tbody>
            </table>
               
                  </div>
  

       <modalfile
      :url="getSelectedDocumentPath()"
      :title="selectedDocument.title"
      :format="selectedDocument.format"
      @close="closeModal()"
      v-if="selectedDocument != undefined && showModalFile"
      v-show="showModalFile"
    ></modalfile>
</div>

</template>

<script>
const modalfile = () => import("@/components/ModalFile.vue");
import { SchoolService } from "@/services/school.service";

export default {
  name: "unitfilelist",
  props: {
    course: Object,
    lesson: Object,
    lessonFiles: Array
  },
  computed: {
    hasLessonFiles() {
      if (this.lessonFiles === undefined) { return false }
      return this.lessonFiles.length > 0
    },
    filesList() {
      var filesInView = this.files
      return _.orderBy(filesInView, ["display_order", "title"]); 
    }
  },
  data: function () {
    return {
      selectedDocument: {},
      showModalFile: false,
      files: []
    };
  },
  created() {
    this.fetchUnitResources();

    // if (this.files.length === 1) {
    //   this.displayResource(this.files[0])
    //   this.cancelSelect()
    // }
  },
  methods: {
    fetchUnitResources() {
      SchoolService.getAll("courses/" + this.course.id + "/resources")
        .then((response) => (this.files = response.data.data))
        .catch((err) => {
          console.log("Resources " + err);
          this.errored = true;
        });
    },
    cancelSelect() {
      this.$emit('close')
    },   
    displayResource(document) {
      this.selectedDocument = document;
      this.showModalFile = true;
    },
    getSelectedDocumentPath() {
      const formats = ['diagram', 'teaching']
      if (this.selectedDocument.folder === 'general' || formats.includes(this.selectedDocument.format)) {
         return this.selectedDocument.url;
      } else {
         return this.selectedDocument.folder + "/" + this.selectedDocument.url;
      }
    },
    showIcon(document) {
      let fileExt = document.url .split(".").pop();
      if (fileExt == "doc") {
        return "fa-file-word";
      } else if (fileExt == "pdf") {
        return "fa-file-pdf";
      } else if (["png", "jpg", "gif"].includes(fileExt)) {
        return "fa-file-image";
      } else if (fileExt == "csv") {
        return "fa-file-csv";
      } else if (["xls", "xlsx"].includes(fileExt)) {
        return "fa-file-exel";
      } else {
        return "fa-file-video";
      }
    },
    closeModal() {
      this.showModalFile = false
      this.cancelSelect()
    }
  },
  components: {
    modalfile
  },
};
</script>

<style scoped>

.table-wrapper tbody tr:last-child {
  border: 0 !important;
}
</style>
